import eventBus from '../../../../_00_elements/tools/event-bus';
import Attach from '../../../../_00_elements/tools/attach';
import Logger from '../../../../_00_elements/tools/logger/logger';
import { URL_CHOICE_REGISTER } from '../../../../_00_elements/tools/routes/routes';
import cookie from '../../../../_00_elements/tools/cookie';
import translation from '../../../../_00_elements/translation';
import Modal from '../../../../_01_atoms/components/Modal.vue';
import requests from '../../../../_00_elements/tools/requests-mixin';

/**
 * Register Choice Modal Component
 * This component use the modal component as a child.
 * It displays the choice for the user to register with social network or classic way.
 */
export default {
  template: '#user-modal-component',
  components: {
    Modal,
  },
  props: [ 'isOpened', 'redirectUrl' ],
  mixins: [ translation, requests ],
  delimiters: [ '${', '}' ],
  data() {
    return {
      htmlBody: '',
      modalTitle: '',
      checked: false,
      newsletterChecked: false,
    };
  },
  methods: {
    close() {
      this.htmlBody = '';
      this.modalTitle = '';
      this.$emit('close');
    },
    switchTo(newModalName, args) {
      this.htmlBody = '';
      this.modalTitle = '';
      eventBus.dispatchEvent(new CustomEvent('switch-from-to-modal', {
        detail: {
          oldModalName: 'RegisterChoice',
          newModalName,
          args,
        },
      }));
    },
    toggleDisableNewsletter() {
      this.$nextTick(() => {
        const newsletterCheckbox = document.getElementById('register_newsletter');

        if (cookie.get('register-newsletter') !== '') {
          cookie.remove('register-newsletter');
        }

        newsletterCheckbox.addEventListener('change', function newsletterChangeState() {
          this.newsletterChecked = !this.newsletterChecked;
          cookie.set('register-newsletter', this.newsletterChecked, 1);
        });
      });
    },
    callChoiceRegister(callback) {
      const redirectUrlSlug = this.redirectUrl ? `?_redirectUrl=${encodeURIComponent(this.redirectUrl)}` : '';
      const FORMATTED_URL_CHOICE_REGISTER = URL_CHOICE_REGISTER + redirectUrlSlug;

      this.get(FORMATTED_URL_CHOICE_REGISTER).then((response) => {
        this.htmlBody = response.data;

        Attach.onClickEvent('header-register-classic', () => {
          this.switchTo('Register', [ this.redirectUrl ]);
        });

        Attach.onClickEvent('switch-connection-button', () => {
          this.switchTo('Login', '', [ this.redirectUrl ]);
        });

        this.$nextTick(() => {
          eventBus.dispatchEvent(new Event('initialize-login-button'));
        });

        callback();
      }).catch((error) => {
        Logger.debug(error);
        callback();
      });
    },
  },
  watch: {
    isOpened(newVal) {
      if (!newVal || (newVal && this.htmlBody !== '')) {
        return;
      }
      this.modalTitle = this.trans('form.register.modal_title');

      this.callChoiceRegister(() => {});
    },
  },
};
